module.exports = __webpack_public_path__ + "static/6931-300w-21763ba6ec6d78926c1df6ff387c7a18.jpg";